export enum UploadTypeEnum {
  USER = "users/",
  RESPONSE = "responses/",
  COMPANY = "companies/",
  CATEGORY = "categories/",
  CAMPAING = "campaigns/",
  GROUP = "groups/",
  MESSAGE = "messages/",
  CHATBOT = "chatbot/",
  CSV = "csv/",
  INFO = "info/",

  TASK = "tasks/",
  DOCUMENT = "documents/",

  // Internal chat attachments (SPEC-2026-07-internal-chat, plan §8) —
  // full path: chat/{companyId}/{channelId}/{filename}
  CHAT = "chat/",

  // Campaign recipient lists. Separate from CSV ("csv/", the contact importer)
  // on purpose: these files are NOT imported into the contact base, and keeping
  // them apart makes that visible in storage instead of only in code.
  CAMPAIGN_AUDIENCE = "campaign-audience/",

  // Webchat channel logo/avatar (channel.metadata.logoUrl) —
  // full path: channels/{companyId}/{filename}
  CHANNEL = "channels/",
}
